import heroBg from '../assets/images/hero_bg.png';
import textLogo from '../assets/images/text_logo.png';
import loginBg from '../assets/images/login_bg.png';
import logo from '../assets/images/logo.png';
import mountains from '../assets/images/mountains.png';
import tadawulaty from '../assets/images/tadawulaty.png';
import excel from '../assets/images/excel.png';
import report from '../assets/images/report.png';
import building from '../assets/images/building.png';
import logoWhite from '../assets/images/logo_white.png';
import reportImg from '../assets/images/report_img.png';
import arab_image from '../assets/images/arab_image.png';
const images = {
    heroBg,
    textLogo,
    loginBg,
    logo,
    mountains,
    tadawulaty,
    excel,
    report,
    building,
    logoWhite,
    reportImg,
    arab_image,
};

export default images;